<ng-template [sbmodal]="'areaSelectionModal'">
  <sb-custom-modal [templateId]="'areaSelectionModal'">
    <div slot="body">
      <sb-page-areas [isInModalContext]="true"></sb-page-areas>
    </div>
  </sb-custom-modal>
</ng-template>

<div class="row">
  <div class="col-12">
    <ng-container *ngIf="easyMode && !loading">
      <div class="row">
        <div [ngClass]="isInSidebarContext ? 'col-12' : 'col-6'">
          <div class="row">
            <!-- ToDo global inverted
            <div class="col-md-12">
              <div class="form-group">
                <div class="form-check form-switch">
                  <input [ngModel]="globalInverted" [disabled]="disabled"
                         (ngModelChange)="toggleGlobalInverted()" type="checkbox" role="switch" class="form-check-input" id="Inverted">
                  <label class="form-check-label"
                         for="Inverted">{{'lang.globals.blacklist' | translate}}</label>
                </div>
                <span *ngIf="!disabled"
                      class="form-text text-muted">{{'lang.globals.blacklistDescription' | translate}}</span>
              </div>
            </div>
            -->
            <div *ngIf="!disabled" class="col-6 mt-2">
              <sb-button (submitClicked)="addAreaRow()" classes="btn-primary m-0 w-100">
                {{'nav.datasets.areas.add' | translate}}</sb-button>
            </div>
            <div *ngIf="!disabled" class="col-6 mt-2">
              <sb-button (submitClicked)="createAreaRow()" classes="btn-success m-0 w-100">
                {{'nav.datasets.areas.create' | translate}}</sb-button>
            </div>
          </div>
          <table class="table tableBg mt-2">
            <thead>
            <tr>
              <th>{{'nav.datasets.areas' | translate}}</th>
              <th>{{'lang.globals.inverted' | translate}}</th>
              <th class="tr">{{ 'lang.mediumExplorer.delete' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let area of selectedEnhancedAreas; index as i">
              <td>
                <span [innerHTML]="area?.areas?.join(', ') ?? '-' | truncate: 45"></span>
              </td>
              <td>
                <div class="form-check form-switch" (click)="toggleInverted($event, area)">
                  <input [ngModel]="area.inverted" type="checkbox" role="switch" class="form-check-input"
                         [id]="area.id">
                  <label class="form-check-label"
                         [for]="area.id">{{'lang.globals.inverted' | translate}}</label>
                </div>
              </td>
              <td class="tr">
                <sb-button *ngIf="!disabled" [disabled]="false" (submitClicked)="removeEnhancedArea(i)"
                           classes="btn-danger mr-0 ml-2">
                  <sb-icon icon="trash"></sb-icon>
                </sb-button>

              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="tabTwo" [ngClass]="isInSidebarContext ? 'col-12' : 'col-6'">
          <sb-polygon-edit-map
            [mapheight]="560"
            [whatIsHere]="false"
            [polygons]="util.geo.polygonDTOArrayToPolygonArray(polygons)"
            [negatedPolygons]="util.geo.polygonDTOArrayToPolygonArray(negPolygons)"
            [readOnly]="true"
            [nominatim]="false" [zoomControl]="false" [initialZoom]="7"
            [roundedCorners]="true">
          </sb-polygon-edit-map>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!easyMode">
      <sb-filter-definition [disabled]="disabled" [preselectType]="true" [isInModalContext]="false" *ngIf="cull"
                            [(cull)]="cull" (cullChange)="emitChange($event)">
      </sb-filter-definition>
    </ng-container>
  </div>
</div>

